'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');
var jsxRuntime = require('react/jsx-runtime');

var SvgFilePdf32 = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = tslib_es6.__rest(_a, ["title", "titleId"]);
    return (jsxRuntime.jsxs("svg", tslib_es6.__assign({ width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-labelledby": titleId }, props, { children: [title ? jsxRuntime.jsx("title", tslib_es6.__assign({ id: titleId }, { children: title })) : null, jsxRuntime.jsxs("g", tslib_es6.__assign({ fill: "none", fillRule: "evenodd" }, { children: [jsxRuntime.jsx("path", { fill: "none", d: "M0 .5h32v32H0z" }), jsxRuntime.jsx("path", { d: "M23.5 12.5H18V7m5.5 5.569V26H8V7h10.01l5.49 5.569h0Zm-8.295 6.997c.83-2.306 1.263-4.802 0-4.562-1.263.24-.352 2.539.592 4.083.945 1.544 2.739 3.274 3.503 2.27.764-1.006-1.247-1.572-3.65-1.427-2.403.146-4.112 1.708-3.327 2.295.785.588 2.053-.352 2.882-2.659Z", strokeLinecap: "square", stroke: "currentColor" })] }))] })));
};

exports.default = SvgFilePdf32;
